$(document).ready(function () {
    $('.multiSelect').SumoSelect();
});